import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CachedPropertiesService, ENVIRONMENT } from '@cfp/core';
import { Alert } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'cfp-login-messages',
  templateUrl: './login-messages.html',
  styleUrls: ['./login-messages.scss'],
  imports: [TranslateModule, Alert]
})
export class LoginMessages {
  public readonly errorMessages = input<string[]>([]);
  public readonly warningMessages = input<string[]>([]);
  public readonly successMessages = input<string[]>([]);
  public readonly interpolateParams = input<Record<string, any>>({});

  protected readonly environment = inject(ENVIRONMENT);
  private readonly cachedPropertiesService = inject(CachedPropertiesService);

  protected readonly loginProperties = toSignal(
    this.cachedPropertiesService.v1PropertiesGet().pipe(catchError(() => of(undefined)))
  );

  protected readonly translateParams = computed(() => ({
    length: this.loginProperties()?.passwordLength,
    ...this.interpolateParams()
  }));
}
